<template>
  <div class="appraiserInfo">
    <div class="form">
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="170px"
          class="demo-ruleForm"
          enctype="multipart/form-data"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="真实姓名" prop="name">
              <el-input
                  type="name"
                  v-model="ruleForm.name"
                  placeholder="请输入您的真实姓名"
                  style="width:100%"
                  :class="isdisabled?'border':''"
                  :readOnly="isdisabled?true:false"
              ></el-input>
              <p class="tips" v-if="!isdisabled">提示：证件登记名称，提交后不可修改</p>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="英文姓名" prop="personal_en_name">
              <el-input
                  type="personal_en_name"
                  v-model="ruleForm.personal_en_name"
                  placeholder="请输入您的英文名"
                  style="width:100%"
                  :class="isdisabled?'border':''"
                  :readOnly="isdisabled?true:false"
              ></el-input>
              <p
                  class="tips"
                  v-if="!isdisabled"
              >提示：（注意大小写，首字母大写）证件登记名称，提交后不可修改。例如：WangXiaoming 或 Wangming</p>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="上传头像">
              <!-- :error="error" :required="true" -->
              <el-upload
                  class="avatar-uploader center"
                  accept=".png, .jpeg, .jpg"
                  action="#"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="loadJsonFromFile"
                  :disabled="disabled"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" @mouseover="imgMouseover"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload-show" :style="active" @mouseleave="imgMouseleave">
                  <span class="el-upload-span1">
                    <span
                        class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview()"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span @click.stop="handleRemove()" v-if="!disabled || !personalInfo">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt/>
              </el-dialog>
              <p class="tips" style="color: red;" v-if="!disabled">请上传近期竖型、红底证件照免冠证件照</p>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="ruleForm.sex" :disabled="isdisabled" v-if="!isdisabled">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
              </el-radio-group>
              <span v-else style="padding: 0 15px;">{{ ruleForm.sex|sex }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="证件类型" prop="certificates_type">
              <el-select
                  v-model="ruleForm.certificates_type"
                  placeholder="请选择证件类型"
                  style="width:100%"
                  :disabled="isdisabled"
                  v-if="!isdisabled"
              >
                <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item,index) in certificatesList"
                    :key="index"
                ></el-option>
              </el-select>
              <span v-else style="padding: 0 15px;">{{ ruleForm.certificates_type|type }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="证件号码" prop="certificates_number">
              <el-input
                  v-model="ruleForm.certificates_number"
                  placeholder="请输入您的证件号码"
                  style="width:100%"
                  :class="isdisabled?'border':''"
                  :readOnly="isdisabled?true:false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="生日" prop="birthday">
              <el-date-picker
                  v-model="ruleForm.birthday"
                  type="date"
                  placeholder="选择您的出生日期"
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  v-if="!isdisabled"
              ></el-date-picker>
              <span v-else style="padding-left:15px;">{{ ruleForm.birthday }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="常住省市区">
              <el-row :gutter="10" style="width:100%;margin-left:0px;" v-if="!disabled">
                <el-col :xs="8" :sm="8" :md="8" style="padding-left:0px;">
                  <el-form-item prop="province" class="content"
                                :rules="[{required: userRole == 2,message: '请选择省',trigger: ['blur','change']}]">
                    <el-select
                        v-model="ruleForm.province"
                        placeholder="请选择省"
                        style="width:100%"
                        :disabled="disabled"
                        @change="chooseProvince($event)"
                    >
                      <el-option
                          v-for="item in province"
                          :key="item.id"
                          :label="item.area_name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8">
                  <el-form-item prop="city" class="content"
                                :rules="[{required: userRole == 2,message: '请选择市',trigger: ['blur','change']}]">
                    <el-select
                        v-model="ruleForm.city"
                        placeholder="请选择市"
                        style="width:100%"
                        :disabled="disabled"
                        @change="chooseCity($event)"
                    >
                      <el-option
                          v-for="item in city"
                          :key="item.id"
                          :label="item.area_name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" style="padding-right:0px;">
                  <el-form-item prop="district" class="content"
                                :rules="[{required: userRole == 2,message: '请选择地区',trigger: ['blur','change']}]">
                    <el-select
                        v-model="ruleForm.district"
                        placeholder="请选择地区"
                        style="width:100%"
                        :disabled="disabled"
                        @change="chooseDistrict($event)"
                    >
                      <el-option
                          v-for="item in district"
                          :key="item.id"
                          :label="item.area_name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <span
                v-else
                style="padding: 0 15px;"
              >{{ruleForm.province|pro}} {{ruleForm.city|cit}} {{ruleForm.district|dis}}</span>-->
              <span
                  v-else
                  style="padding: 0 15px;"
              >
                {{
                  ruleForm.provinceName == ruleForm.cityName ? ruleForm.provinceName : ruleForm.provinceName + ruleForm.cityName
                }}
                {{ ruleForm.districtName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="详细地址" prop="native_place"
                          :rules="[{required: userRole == 2,message: '请输入详细地址',trigger: ['blur','change']}]">
              <el-input
                  v-model="ruleForm.native_place"
                  placeholder="请输入您的详细地址"
                  style="width:100%"
                  :class="disabled?'border':''"
                  :readOnly="disabled?true:false"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" style="display: none;">
            <el-form-item label="邮寄地址" prop="mailing_address">
              <el-input
                  v-model="ruleForm.mailing_address"
                  placeholder="证书邮寄地址,请具体到门牌号"
                  style="width:100%"
                  :class="disabled?'border':''"
                  :readOnly="disabled?true:false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="userRole == '2'">
            <el-form-item label="教育程度" prop="educational_information">
              <el-select
                  v-model="ruleForm.educational_information"
                  placeholder="请选择您的教育程度"
                  style="width:100%"
                  v-if="!disabled"
              >
                <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item,index) in educationList"
                    :key="index"
                ></el-option>
              </el-select>
              <span v-else style="padding: 0 15px;">{{ ruleForm.educational_information|educational }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item prop="email" label="邮箱">
              <el-input
                  v-model="ruleForm.email"
                  placeholder="请输入您的邮箱"
                  :class="disabled?'border':''"
                  :readOnly="disabled?true:false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="userRole == '1' && personalInfo">
            <el-form-item label="当前运动员等级" prop="athlete_rank">
              <!-- <el-input v-model="ruleForm.athlete_rank" placeholder="请填写当前等级" style="width:100%"></el-input> -->
              <span
                  v-if="ruleForm.athlete_rank"
                  style="padding: 0 15px;"
              >{{ ruleForm.athlete_rank|grade }}</span>
              <span v-else style="padding: 0 15px;">无等级</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="userRole == '1' && personalInfo">
            <el-form-item label="获取当前运动员等级时间" prop="athlete_obtain_time">
              <span
                  style="padding: 0 15px;"
                  v-if="ruleForm.athlete_obtain_time"
              >{{ ruleForm.athlete_obtain_time|dateformat("YYYY-MM-DD HH:mm") }}</span>
              <span v-else style="padding: 0 15px;">无等级获取时间</span>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" v-if="userRole == '2' && personalInfo">
            <el-form-item label="当前考评员等级" prop="evaluator_rank">
              <span
                  v-if="ruleForm.evaluator_rank"
                  style="padding: 0 15px;"
              >{{ ruleForm.evaluator_rank|app_grade }}</span>
              <span v-else style="padding: 0 15px;">无等级</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="userRole == '2' && personalInfo">
            <el-form-item label="获取当前考评员等级时间" prop="athlete_obtain_time">
              <span
                  v-if="ruleForm.evaluator_obtain_time"
                  style="padding: 0 15px;"
              >{{ ruleForm.evaluator_obtain_time|dateformat("YYYY-MM-DD HH:mm") }}</span>
              <span v-else style="padding: 0 15px;">无等级获取时间</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="!disabled">
            <el-form-item label="友情提示!" class="color">
              <div class="friendshipTips">
                <p>
                  <span>您的中文姓名、英文姓名、性别、出生年月日 将会出现在各类证书 上，一旦提交无法自行修改，是否确认。</span>
                </p>
                <p>
                  <el-button type="warning" @click="sure('ruleForm')" :disabled="isdisabled">确认</el-button>
                </p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="isdisabled">
            <el-form-item class="submit">
              <el-button
                  type="danger"
                  @click="edit('ruleForm')"
                  style="width:100px;height:40px"
                  v-if="disabled"
              >编 辑
              </el-button>
              <el-button
                  type="danger"
                  @click="edit1('ruleForm')"
                  style="width:100px;height:40px"
                  v-if="!disabled && personalInfo"
              >取消编辑
              </el-button>
              <el-button
                  type="danger"
                  @click="submit('ruleForm')"
                  style="width:100px;height:40px"
                  v-if="!disabled"
              >提 交
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import {GetDistrictList, GetDicData} from "@/api/admin/common.js";
import {
  UpdateorInsertAthleteInfo,
  UpdateorInsertCoachInfo
} from "@/api/admin/login.js";
import {
  validatename,
  validateEname,
  validateCapnanme,
  //   check,
  cardid,
  checkPassport,
  isTWCard,
  isHKCard
} from "@/util/validate.js";
import {getBirthdayFromIdCard} from "@/util/data.js";
import {mapGetters} from "vuex";
// 英名验证
const enName = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入英文名"));
  } else {
    if (validateCapnanme(value)) {
      return callback(new Error("首字母未大写"));
    } else if (value.length < 100 && validateEname(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的英文名"));
    }
  }
};
// 中名验证
const chnName = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入中文名"));
  } else {
    if (value.length < 100 && validatename(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的中文名"));
    }
  }
};

// 验证身份证是否正确
const chnNumber = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入身份证号码"));
  } else {

    if (cardid(value).status) {
      callback();
    } else {
      return callback(new Error(cardid(value).msg));
    }
  }
};
// 验证港澳居民
const chnNumber1 = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入港澳居民来往内地通行证身份证号码"));
  } else {

    if (isHKCard(value).status) {
      callback();
    } else {
      return callback(new Error(isHKCard(value).msg));
    }
  }
};
// 验证台湾身份证
const chnNumber2 = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入台湾居民来往大陆通行证身份证号码"));
  } else {

    if (isTWCard(value).status) {
      callback();
    } else {
      return callback(new Error(isTWCard(value).msg));
    }
  }
};
// 验证护照是否正确
const chnPassport = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入护照号码"));
  } else {

    if (checkPassport(value).errCode) {
      callback();
    } else {
      return callback(new Error(checkPassport(value).errMsg));
    }
  }
};
//声明一个全局变量
let that;
export default {
  computed: {
    ...mapGetters(["userRole", "personalInfo", "userInfo"])
  },
  data() {
    return {
      ruleForm: {
        certificates_type: "1"
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "blur",
            validator: chnName
          }
        ],
        personal_en_name: [
          {
            required: true,
            trigger: "blur",
            validator: enName
          }
        ],
        sex: [{required: true, message: "请选择性别", trigger: "change"}],
        certificates_type: [
          {required: true, message: "请选择证件类型", trigger: "change"}
        ],
        certificates_number: [
          {required: true, validator: chnNumber, trigger: "blur"}
        ],
        birthday: [
          {required: true, message: "请选择出生日期", trigger: "change"}
        ],
        // mailing_address: [
        //    { required: true, message: "请输入邮寄地址", trigger: "blur" }
        // ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ]
        // educational_information: [
        //    { required: true, message: "请选择教育程度", trigger: "change" }
        // ]
      },
      province: [],
      city: [],
      district: [],
      disabled: false,
      isdisabled: false,
      loading: false,
      dicData: {
        certificates_type: "certificates_type",
        education: "education",
        certificate_grade: "certificate_grade"
      },
      educationList: [],
      certificatesList: [],
      uploadFiles: [],
      localFile: {},
      error: "",
      dialogVisible: false,
      dialogImageUrl: "",
      active: "",
      imageUrl: "",
      certificate_grade: [],
      appraiser_grade: []
    };
  },
  watch: {
    // "ruleForm.province"(val) {
    //    GetDistrictList({ parent_id: val }).then(data => {
    //       this.city = data.data.result.items;
    //       this.ruleForm.city = this.city[0].id;
    //       this.chooseCity(this.ruleForm.city);
    //    });
    // },
    "ruleForm.certificates_number"(val) {
      if (getBirthdayFromIdCard(val)) {
        this.$set(this.ruleForm, "birthday", getBirthdayFromIdCard(val));
      }
    },
    //  "ruleForm.birthday"(val) {
    //      this.$refs.ruleForm.clearValidate("birthday");
    //    if (!check(val)) {
    //      this.ruleForm.birthday = "";
    //    }
    //  },
    "ruleForm.certificates_type"(val) {
      this.$refs.ruleForm.clearValidate("certificates_number");
      if (val == "1") {
        this.rules.certificates_number[0].validator = chnNumber;
      } else if (val == "2") {
        this.rules.certificates_number[0].validator = chnNumber1;
      } else if (val == "3") {
        this.rules.certificates_number[0].validator = chnNumber2;
      } else if (val == "4") {
        this.rules.certificates_number[0].validator = chnPassport;
      }
    }
  },
  created() {
    this.getList();
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    getList() {
      // 数据回填
      this.$store.dispatch("GetPersonalInfo", this.userInfo).then(data => {

        if (this.personalInfo) {
          this.isdisabled = true;
          this.disabled = true;
          this.ruleForm = data.userInfo;
          this.imageUrl = window.apiObj.apiUrl + data.userInfo.photo_path;
          if (!data.userInfo.photo_path) {
            this.imageUrl = "/image/personal/morentx.png";
          }
          GetDistrictList({parent_id: "-1"}).then(data => {
            if (data.data.result) {
              this.province = data.data.result.items;
            }
          });
          GetDistrictList({parent_id: this.ruleForm.province}).then(data => {
            if (data.data.result) {
              this.city = data.data.result.items;
            }
          });
          GetDistrictList({parent_id: this.ruleForm.city}).then(data => {
            if (data.data.result) {
              this.district = data.data.result.items;
            }
          });
        } else {
          this.isdisabled = false;
          this.disabled = false;
          this.ruleForm = {
            certificates_type: "1"
          };
        }
      });
      GetDistrictList({parent_id: "-1"}).then(data => {
        if (data.data.result) {
          this.province = data.data.result.items;
        }
      });
      GetDicData({classCode: this.dicData.certificates_type}).then(data => {
        if (data.data.result.length > 0) {
          this.certificatesList = data.data.result;
        }
      });
      GetDicData({classCode: "appraiser_grade"}).then(data => {
        if (data.data.result) {
          this.appraiser_grade = data.data.result;
        }
      });
      GetDicData({classCode: this.dicData.education}).then(data => {
        if (data.data.result.length > 0) {
          this.educationList = data.data.result;
        }
      });
      GetDicData({classCode: this.dicData.certificate_grade}).then(data => {
        if (data.data.result.length > 0) {
          this.certificate_grade = data.data.result;
        }
      });
    },
    sure(ruleForm) {

      // this.ruleForm.athletes_photo = this.localFile;
      // if (!this.imageUrl) {
      //    this.error = "请上传头像";
      // } else {
      //    this.error = "";
      // }
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.isdisabled = true;
          // if (this.imageUrl) {
          //    this.error = "";
          //    this.isdisabled = true;
          //    // this.disabled = true
          // }
        } else {
          return false;
        }
      });
    },
    submit(ruleForm) {
      this.ruleForm.isFormSubmit = true;

      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$confirm("带*号信息为关键信息，提交后无法自行修改，请确认后提交?", "确认信息", {
            distinguishCancelAndClose: true,
            confirmButtonText: "提交"
          }).then(() => {
            if (this.userRole == "1") {
              UpdateorInsertAthleteInfo(this.ruleForm).then(data => {
                if (data.data.result.isSuccess == true) {
                  this.isdisabled = true;
                  this.disabled = true;
                  this.$router.go(0);
                } else {
                  this.isdisabled = false;
                  alert(data.data.result.errorMsg);
                }
                // this.$store
                //    .dispatch("GetPersonalInfo", this.userInfo)
                //    .then(data => {
                //       // this.$router.go(0)
                //    });
              });
            } else if (this.userRole == "2") {
              UpdateorInsertCoachInfo(this.ruleForm).then(data => {
                if (data.data.result.isSuccess == true) {
                  this.isdisabled = true;
                  this.disabled = true;
                  window.location.reload();
                } else {
                  this.isdisabled = false;
                  alert(data.data.result.errorMsg);
                }

              });
            }
          });
        } else {
          return false;
        }
      });
    },
    edit() {
      this.disabled = false;
    },
    edit1() {
      this.disabled = true;
    },
    loadJsonFromFile(file) {
      this.localFile = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile);
      reader.onload = () => {
        const isJPG =
            this.localFile.type === "image/jpeg" ||
            this.localFile.type === "image/png";
        const isLt4M = this.localFile.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.localFile = {};
          this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
        } else {
          this.imageUrl = reader.result;
          this.ruleForm.athletes_photo = this.localFile;
        }
        if (!isLt4M) {
          this.$message.error("上传头像图片大小不能超过 1MB!");
        }
        return isJPG && isLt4M;
      };
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1;";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
    handlePictureCardPreview() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    handleRemove() {
      this.imageUrl = "";
      this.localFile = {};
      // this.ruleForm.athletes_photo = ""
      this.active = "display:none;opacity: 0;";
    },
    chooseProvince(item) {
      GetDistrictList({parent_id: item}).then(data => {
        this.city = data.data.result.items;
        this.ruleForm.city = this.city[0].id;
        GetDistrictList({parent_id: this.ruleForm.city}).then(data => {
          this.district = data.data.result.items;
          this.ruleForm.district = this.district[0].id;
        });
      });
    },
    chooseCity(item) {
      GetDistrictList({parent_id: item}).then(data => {
        this.district = data.data.result.items;
        this.ruleForm.district = this.district[0].id;
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    }
  },
  filters: {
    grade: data => {
      for (var i in that.certificate_grade) {
        if (that.certificate_grade[i].value == data) {
          return that.certificate_grade[i].label;
        }
      }
    },
    app_grade: data => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    },
    type: data => {
      for (var i in that.certificatesList) {
        if (that.certificatesList[i].value == data) {
          return that.certificatesList[i].label;
        }
      }
    },
    educational: data => {
      for (var i in that.educationList) {
        if (that.educationList[i].value == data) {
          return that.educationList[i].label;
        }
      }
    },
    sex: data => {
      switch (data) {
        case 0:
          return "男";
        case 1:
          return "女";
      }
    },
    pro: data => {
      for (var i in that.province) {
        if (that.province[i].id == data) {
          return that.province[i].area_name;
        }
      }
    },
    cit: data => {
      for (var i in that.city) {

        if (that.city[i].id == data) {
          return that.city[i].area_name;
        }
      }
    },
    dis: data => {
      for (var i in that.district) {
        if (that.district[i].id == data) {
          return that.district[i].area_name;
        }
      }
    }
  }
};
</script>
<style lang="less">
.appraiserInfo {
  .form {
    width: 90%;

    .tips {
      font-weight: 350;
      color: #4e4e4e;
      line-height: 30px;
    }

    .friendshipTips {
      display: flex;

      p:nth-child(1) {
        padding: 0px 40px 0px 0px;
      }

      p:nth-child(2) {
        line-height: 5;
      }
    }

    .color {
      color: #ea0000;

      .el-form-item__label {
        color: #ea0000;
      }
    }

    // 去掉边框
    .border {
      .el-input__inner {
        border-width: 0px !important;
      }
    }

    .submit {
      .el-form-item__content {
        margin-left: 0px !important;
        text-align: center;
        margin: 30px 0px;
      }
    }

    .avatar-uploader {
      position: relative;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

    .el-upload-show {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      display: none;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      line-height: 9;

      .el-upload-span1 {
        span {
          padding: 0px 20px;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    .form {
      width: 100% !important;

      .el-form-item__label {
        width: 110px !important;
        float: none;
      }

      .el-form-item__content {
        margin-left: 0px !important;
        float: none;
      }

      .center {
        text-align: center;
      }

      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
    }
  }
}
</style>
